var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLength = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.441 8.88-4.758 2.746v-2.05l2.536-1.617-.062.104v-.24l.062.1L1.683 6.31V4.256L6.44 7.002zM13.624 4.398q-.44-.565-1.206-.89-.765-.325-1.745-.325t-1.746.325-1.206.89-.44 1.287q0 .763.486 1.333.486.569 1.248.708v.072a2.6 2.6 0 0 0-1.054.41 2.4 2.4 0 0 0-.747.796q-.276.48-.276 1.053 0 .75.481 1.343.48.595 1.328.94t1.926.345l.131-.001a4.389 4.389 0 0 1 .142-1.603 2 2 0 0 1-.273.019q-.406 0-.72-.158a1.23 1.23 0 0 1-.493-.436 1.14 1.14 0 0 1-.178-.63c0-.235.06-.454.18-.641q.181-.28.498-.44.315-.161.713-.16c.264 0 .507.052.716.16a1.25 1.25 0 0 1 .536.51c.41-.456.914-.825 1.481-1.08l-.026-.017a2.6 2.6 0 0 0-1.05-.41v-.072a2.1 2.1 0 0 0 1.245-.706q.49-.567.49-1.335 0-.723-.44-1.287m-1.896 2.113a1.1 1.1 0 0 1-.429.403 1.3 1.3 0 0 1-.626.144q-.35 0-.623-.147a1.09 1.09 0 0 1-.587-.982q0-.325.153-.574.154-.248.43-.39.274-.142.627-.142c.235 0 .447.047.627.142q.273.142.428.39t.155.574a1.1 1.1 0 0 1-.155.582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBB17",
    d: "M15.206 9.207a3.057 3.057 0 1 0 0 6.115 3.057 3.057 0 0 0 0-6.115m1.457 4.606c0 .2-.164.365-.364.365h-2.187a.366.366 0 0 1-.364-.365v-1.822c0-.2.164-.364.364-.364h.183v-.364a.91.91 0 1 1 1.821 0v.364h.183c.2 0 .364.164.364.364zm-1.457-3.115a.566.566 0 0 0-.565.565v.364h1.13v-.364a.565.565 0 0 0-.565-.565m0 1.84c-.2 0-.365.164-.365.364s.164.365.365.365a.365.365 0 0 0 0-.73",
    className: "lock"
  })));
};
export default SvgLength;